export default "__VITE_ASSET__b59ad885__"